"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useCheckAuth;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _profile = require("@widget/profile");

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var AUTH_STATE = 'auth';
var NOT_AUTH_STATE = 'not-auth';

function useCheckAuth() {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      authState = _useState2[0],
      setAuthState = _useState2[1];

  (0, _react.useEffect)(function () {
    function init() {
      return _init.apply(this, arguments);
    }

    function _init() {
      _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
        var profile;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch((0, _profile.getProfile)());

              case 2:
                profile = _context.sent;
                setAuthState(!!profile ? AUTH_STATE : NOT_AUTH_STATE);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _init.apply(this, arguments);
    }

    init();
  }, []);
  return authState;
}